import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const Languages = ["en", "srsr", "srba"];

const languageSelected = Languages[0];

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    lng: languageSelected,
    fallbackLng: languageSelected,
    debug: false,
    whitelist: Languages,
    // backend: {
    //   loadPath: `/bergmanntest/locales/{{lng}}/{{ns}}.json`,
    // },
    interpolation: {
      escapeValue: false, // Not needed for React as it escapes by default
    },
  });

export default i18n;
